import { useEffect } from 'react';
import { Button } from '@/shared/ui/button';

const LOGIN_URL = '/login';
const REDIRECT_DELAY_MS = 1500;

export function LoggedOutPage() {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      window.location.replace(LOGIN_URL);
    }, REDIRECT_DELAY_MS);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <main
      aria-labelledby="logged-out-heading"
      className="flex min-h-screen items-center justify-center p-8"
    >
      <section className="flex w-full max-w-120 flex-col items-center gap-4 text-center">
        <h1 id="logged-out-heading" className="text-xl font-semibold">
          Logged out
        </h1>
        <p>You have been signed out. Redirecting you to the login screen.</p>
        <div className="flex w-full justify-center">
          <Button
            onClick={() => {
              window.location.replace(LOGIN_URL);
            }}
          >
            Back to login
          </Button>
        </div>
      </section>
    </main>
  );
}
